/**
 * Platform Registry
 * Central configuration for sprite icon indices and brand colors
 * 
 * This is the single source of truth for platform visual configuration.
 * Colors can be hex values (e.g., '#1877F2') or CSS gradients (e.g., 'linear-gradient(...)').
 */

export const PlatformRegistry = {
  facebook:  { index: 0,  color: '#1877F2' },
  line:      { index: 2,  color: '#06C755' },
  kakao:     { index: 3,  color: '#FFE812' },
  naver:     { index: 4,  color: '#03CF5D' },
  plurk:     { index: 5,  color: '#FF574D' },
  copylink:  { index: 6,  color: '#6B7280' },
  // Messenger: Use a gradient to look modern (Blue to Purple)
  messenger: { index: 7,  color: 'linear-gradient(45deg, #0088FF 0%, #A033FF 100%)' },
  qzone:     { index: 8,  color: '#E6B845' },
  tumblr:    { index: 9,  color: '#001935' },
  twitter:   { index: 10, color: '#1D9BF0' },
  vk:        { index: 11, color: '#0077FF' },
  pinterest: { index: 12, color: '#BD081C' },
  weibo:     { index: 13, color: '#E6B845' },
  reddit:    { index: 14, color: '#FF4500' },
  ok:        { index: 15, color: '#EE8208' },
  whatsapp:  { index: 16, color: '#2FB943' },
  linkedin:  { index: 17, color: '#0A66C2' },
  telegram:  { index: 18, color: '#2AABEE' },
  email:     { index: 19, color: '#939393' },
  hatena:    { index: 20, color: '#00A4DE' },
  threads:   { index: 21, color: '#000000' },
  x:         { index: 22, color: '#000000' },
  snapchat:  { index: 23, color: '#FFFC00' },
  instagram: { index: 24, color: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)' },
  discord:   { index: 25, color: '#5865F2' },
  viber:     { index: 26, color: '#7360F2' },
  classroom: { index: 27, color: '#0F9D58' },
} as const;

export type PlatformRegistryKey = keyof typeof PlatformRegistry;
